import script from "./ReaderMapComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ReaderMapComponent.vue?vue&type=script&setup=true&lang=js"

import "./ReaderMapComponent.vue?vue&type=style&index=0&id=7410485e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7410485e"]])

export default __exports__